import { isEmpty, isNil, map, not } from 'ramda';
import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';

import flexible from '@ui/styled/Flexible';

export interface IProductPrice {
	value: string | number;
	interval?: string | number;
	additional?: boolean;
	finePrint?: string;
}

interface IProductCardProps {
	headerText: string;
	bodyText: string;
	borderless?: boolean;
	footerText?: string;
	name?: string;
	prices?: IProductPrice[];
	className?: string;
}

const FlexibleColumn = flexible(FlexColumn);

const FooterText = styled.div`
	display: flex;
	align-items: baseline;
`;

const ProductCard: FC<IProductCardProps> = ({
	borderless = false,
	className = '',
	headerText,
	bodyText,
	footerText,
	name,
	prices = [],
}) => {
	const Header = (
		<SubheadingText>
			<label htmlFor={name}>{headerText}</label>
		</SubheadingText>
	);
	const Body = <BasicText>{bodyText}</BasicText>;
	const Footer = (
		<FlexibleColumn gap="xs">
			{map(
				(price) => (
					<FooterText>
						<SubheadingText>{`${price?.additional ? '+' : ''}$${price.value}`}</SubheadingText>
						{!!price?.interval && <SubheadingText>{`-${price.interval}`}</SubheadingText>}
						{!!price?.finePrint && (
							<BasicText variant="fineprint">&nbsp;{price.finePrint}</BasicText>
						)}
					</FooterText>
				),
				prices
			)}
			{!!footerText && <BasicText variant="fineprint">{footerText}</BasicText>}
		</FlexibleColumn>
	);

	return (
		<BaseCard
			className={className}
			header={Header}
			body={Body}
			footer={not(isEmpty(prices)) && Footer}
			borderless={borderless}
		/>
	);
};

export default styled(ProductCard)``;
